import { Cta, isRepeatableCta } from "kadow-jetpack-model";

/**
 * Sorts CTAs so that repeatable ones are at the end, preserving order otherwise.
 * @param ctas - Array of CTAs to sort
 * @returns Sorted array with repeatable CTAs at the end
 */
export default function sortCtasWithRepeatableAtEnd(ctas: Cta[]): Cta[] {
  return [...(ctas || [])].sort((a, b) => {
    const aIsRepeatable = isRepeatableCta(a.id);
    const bIsRepeatable = isRepeatableCta(b.id);

    if (aIsRepeatable && !bIsRepeatable) {
      return 1;
    }

    if (!aIsRepeatable && bIsRepeatable) {
      return -1;
    }

    return 0;
  });
}
